<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="查看当前水表" subheading="" />
      <div class="header-btn-box">
        <a @click="ToModifyDevice">修改</a>
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">水表名称：</div>
        <div>{{name || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">水表序列号：</div>
        <div>{{code || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">水表厂家：</div>
        <div>{{meterDeviceManufacturerName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">水表型号：</div>
        <div>{{meterDeviceModelName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">水表类型：</div>
        <div>{{waterDeviceType || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">接入方式：</div>
        <div>{{accessType || '无'}}</div>
      </div>
      <div class="form-line" v-if="accessType === '有线'">
        <div class="line-text">水表所属集中器：</div>
        <div>{{waterControlDeviceName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">倍率配置：</div>
        <div>{{mutualInductorOnOrOff || '无'}}</div>
      </div>
      <div class="form-line" v-if="mutualInductorOnOrOff === '是'">
        <div class="line-text">倍率：</div>
        <div>{{powerRate || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">水表级别：</div>
        <div>{{levelName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">上级水表：</div>
        <div>{{parentDeviceName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">水表所在楼栋：</div>
        <div>{{buildingName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">水表所在房间：</div>
        <div>{{roomNumber || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">场景：</div>
        <div>{{sceneName || '无'}}</div>
      </div>

      <div class="form-line" >
        <div class="line-text">初始水量：</div>
        <div>{{waterity || '0'}}吨</div>
      </div>
      <div class="form-line" >
        <div class="line-text">数据上报类型：</div>
        <div v-if="useType === '1'">自动上报</div>
        <div v-if="useType === '2'">扫码上报</div>
      </div>
<!--      <div class="form-line" >-->
<!--        <div class="line-text">通讯类型：</div>-->
<!--        <div>{{communicationType || '无'}}</div>-->
<!--      </div>-->
      <!--      <div class="form-line" >-->
      <!--        <div class="line-text">水表计费：</div>-->
      <!--        <div v-if="waterFeeTypeState">是</div>-->
      <!--        <div v-else>否</div>-->
      <!--      </div>-->
      <div class="form-line" v-if="autoOffSupportState">
        <div class="line-text">欠费是否关闸：</div>
        <div v-if="breaker">是</div>
        <div v-else>否</div>
      </div>
      <!--      <div class="form-line" >-->
      <!--        <div class="line-text">水表数据统计：</div>-->
      <!--        <div v-if="whetherToCount">是</div>-->
      <!--        <div v-else>否</div>-->
      <!--      </div>-->
      <div class="form-line" >
        <div class="line-text">设备位置：</div>
        <div>{{location || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">备注：</div>
        <div>{{memo || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">责任人：</div>
        <div v-if="responsiblePerson && personPhone">{{responsiblePerson+'/'+personPhone || '无'}}</div>
        <div v-else>无</div>
      </div>
    </form>
  </div>
</template>

<script>
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import InputTree from "../../../components/common/inputs/input-tree";
import { api } from "../../api/WaterManagement";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: "controller-current",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧用水",
            name: "water-over-view"
          },
          {
            value: "水表管理"
          }
        ]
      },
      autoOffSupportState: false,
      name: "",
      code: "",
      meterDeviceType: "",
      deviceCode: "",
      meterDeviceManufacturerName: "",
      meterDeviceModelName: "",
      waterDeviceType: '',
      accessType: "",
      waterControlDeviceName: "",
      buildingName: "",
      roomNumber: "",
      sceneName: "",
      useType: "",
      powerOnOrOff: "",
      mutualInductorOnOrOff: "",
      waterity: "",
      location: '',
      memo: "",
      communicationType: "",
      breaker: false,
      whetherToCount: false,
      waterFeeTypeState: false,
      powerRate: "",

      levelList: [
        {
          name: "一级",
          code: 1
        },
        {
          name: "二级",
          code: 2
        },
        {
          name: "三级",
          code: 3
        },
        {
          name: "四级",
          code: 4
        },
        {
          name: "五级",
          code: 5
        }
      ],
      levelName: "",
      parentDeviceName: "",
      responsiblePerson:'',
      personPhone:''
    };
  },
  created() {
    this.autoOffSupport();
    this.deviceCode = this.$route.params.id;
    this.getWaterMeterDeviceByCode();
  },
  methods: {
    remoteMethod (query) {
      this.getResponsiblePersonList(query)
    },
    // 获取责任人列表
    getResponsiblePersonList (searchKey) {
      this.$axios.post(`${api.getResponsiblePersonList}?searchKey=${searchKey || ''}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone}`
            })
            this.responsiblePersonList = list
            let res1 = this.responsiblePersonList.find(item=>item.code===this.personCode)||{}
            this.personPhone=res1.phone
          }
        })
        .catch(errorHandler('获取责任人列表失败'))
    },
    // 查询是否可配置欠费是否关闸
    autoOffSupport() {
      this.$axios
        .get(api.autoOffSupport, {})
        .then(res => {
          this.autoOffSupportState = res.data.data;
        })
        .catch(errorHandler("查询配置信息失败"));
    },
    getWaterMeterDeviceByCode() {
      this.$axios
        .get(`${api.getWaterMeterDeviceByCode}/${this.deviceCode}`, {})
        .then(res => {
          let data = res.data.data;
          this.name = data.name;
          this.code = data.code;
          this.sceneName = data.sceneName;
          this.useType = data.useType;
          this.meterDeviceType = data.meterDeviceType;
          this.meterDeviceManufacturerName = data.meterDeviceManufacturerName;
          this.meterDeviceModelName = data.meterDeviceModelName;
          this.waterDeviceType = data.waterDeviceType
          this.accessType = data.accessType;
          this.waterControlDeviceName = data.waterControlDeviceName;
          this.buildingName = data.buildingName;
          this.powerRate = data.powerRate;
          this.roomNumber = data.roomNumber;
          this.waterity = data.waterity;
          this.communicationType = data.communicationType;
          this.powerOnOrOff = data.powerOnOrOff;
          this.whetherToCount = data.whetherToCount;
          if (data.autoOff === "1") {
            this.breaker = true;
          } else {
            this.breaker = false;
          }
          if (data.waterFeeType === "1") {
            this.waterFeeTypeState = true;
          } else {
            this.waterFeeTypeState = false;
          }
          if (data.whetherToCount === "1") {
            this.whetherToCount = true;
          } else {
            this.whetherToCount = false;
          }
          console.log(data.mutualInductorOnOrOff)
          this.mutualInductorOnOrOff = data.mutualInductorOnOrOff === '1' ? '是' : '否'
          this.memo = data.memo;
          this.location = data.location

          this.levelList.map(v => {
            if (data.level === v.code) {
              this.levelName = v.name;
            }
          });
          this.parentDeviceName = data.parentDeviceName;
          this.responsiblePerson = data.personName||''
          this.personCode=data.personCode
          this.remoteMethod()
        })
        .catch(errorHandler("获取水表数据失败"));
    },
    strategyCenter() {
      this.$router.push({
        name: "water-ammeter-management"
      });
    },
    ToModifyDevice() {
      this.$router.push({
        path: "/water_ammeter_modify/" + this.$route.params.id
      });
    }
  }
};
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a {
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover {
  color: #00a0e6;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 160px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/WaterManage/AmmeterManagement/AmmeterCurrent.vue